import { 
  ENTITY_FETCH_LIST_REQUEST,
  ENTITY_RESET_LIST 
} from './entity.constants';

/**
 * Action creator to request the entity list from the API.
 * 
 * @param {string} payload - The entity type (e.g., 'MERCHANT', 'AGGREGATOR', etc.)
 * @param {object} entityData - Additional filter data (e.g., { entityName: '', entityCode: '' })
 * @returns {object} Action to be handled by the saga
 */
export const fetchEntityListRequest = (payload, entityData) => {
  return {
    type: ENTITY_FETCH_LIST_REQUEST,
    payload,
    entityData,
  };
};

/**
 * Action creator to reset the entity list state to initial values.
 * 
 * @returns {object} Action that resets the entity reducer state
 */
export const resetEntityList = () => ({
  type: ENTITY_RESET_LIST,
});
